// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bj-4";
export var collapsed = "_bj-1";
export var headerBar = "_bj-0";
export var leftHeaderContent = "_bj-3";
export var subjectContainer = "_bj-2";